import { CollapseComp } from 'components/CollapseStyle/index'
import {
  Container,
  LeftDiv,
  StepRoundFlex,
  StepsFlex,
  StickyDiv,
  Titlediv,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/style'
import React, { useEffect, useState } from 'react'
import { StatusWrapper } from '../../../../../../../Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import EvaluationStatus from '../EvaluationStatus'
import AntdStepsWithPanel from './AntdStepWithPanel'
import { EvaluationCard, HeaderCard, RightFlex } from './style'

const { Panel } = CollapseComp

const getInterviewDescription = round => {
  if (!round) return null

  const { interviewType, faceToFaceType, assesmentType } = round

  switch (interviewType) {
    case 'GROUP':
      return 'Group Discussion'
    case 'FACE_TO_FACE':
      switch (faceToFaceType) {
        case 'DOMAIN_EXPERTS':
          return 'Domain Experts Interview'
        case 'HR_ROUND':
          return 'HR Interview'
        default:
          return null
      }
    case 'ASSESMENT':
      switch (assesmentType) {
        case 'COGNITIVE':
          return 'Cognitive Assessment'
        case 'TECHNICAL':
          return 'Technical Assessment'
        case 'COMUNICATION':
          return 'Communication Assessment'
        default:
          return null
      }
    case 'EXTERNAL_ASSESMENT':
      switch (assesmentType) {
        case 'TEST_GORILA':
          return 'Test Gorila'
        case 'E_SKILL':
          return 'E-Skill'
        default:
          return null
      }
    default:
      return null
  }
}

const Evaluation = ({ selectedRound, applicantMetrics, evaluationData }) => {
  const [completedStep, setCompletedStep] = useState()
  const [current, setCurrent] = useState(null)
  useEffect(() => {
    let names = applicantMetrics?.round?.map(({ roundName }, index) => {
      return roundName
    })
    setCompletedStep(names?.indexOf(selectedRound))
  }, [selectedRound, applicantMetrics])

  const onChange = value => {
    setCurrent(value)
  }

  const stepsData = evaluationData?.map((round, index) => {
    return {
      key: index,
      activeKey: index,
      status: round?.status,
      interviewArray: round?.studentInterviewMap,
      title: (
        <CollapseComp
          key={index + 'stepsIndex'}
          defaultActiveKey={[index + 1]}
          onChange={onChange}
          expandIconPosition={'end'}
          accordion
          bordered={false}
          expandIcon={() => null}
          value={current}
        >
          <Panel
            header={
              <StepsFlex>
                <StepRoundFlex column>
                  <Titlediv>{round?.interviewRound}</Titlediv>
                </StepRoundFlex>
                <StatusWrapper>
                  <EvaluationStatus
                    status={
                      round?.studentInterviewMap?.length > 0 && round?.status
                    }
                  />
                </StatusWrapper>
              </StepsFlex>
            }
            key={index + 1}
            collapsible={'disabled'}
          >
            <p>
              {round?.studentInterviewMap?.[0]?.feedback != null && (
                <EvaluationCard>
                  <HeaderCard
                    style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                      background: 'white',
                    }}
                  >
                    <div>{getInterviewDescription(round)}</div>
                    <div>
                      {Number?.isInteger(round?.avgMark)
                        ? round?.avgMark
                        : typeof round?.avgMark === 'string'
                        ? parseFloat(round?.avgMark)
                        : typeof round?.avgMark === 'number'
                        ? round?.avgMark?.toFixed(2)
                        : 'N/A'}
                      {(round?.interviewType === 'ASSESMENT' ||
                        round?.interviewType === 'EXTERNAL_ASSESMENT') &&
                        '%'}
                    </div>
                  </HeaderCard>
                  <div style={{ display: 'flex', overflowX: 'auto' }}>
                    {round?.studentInterviewMap?.map((items, index) =>
                      items?.feedback?.map((item, innerIndex) => (
                        <RightFlex
                          key={innerIndex + index + 'data'}
                          style={{
                            borderRight:
                              innerIndex < items?.feedback?.length - 1
                                ? '1px solid #E6E7EA'
                                : 'none',
                          }}
                        >
                          <div style={{ marginBottom: '15px' }}>
                            {item?.type}
                          </div>
                          <div style={{ paddingLeft: '8px' }}>
                            {Number?.isInteger(item?.value)
                              ? item?.value > 0 ? item?.value : 'N/A'
                              : typeof item?.value === 'string'
                              ? parseFloat(item?.value)
                              : typeof item?.value === 'number'
                              ? item?.value?.toFixed(2) > 0 ? item?.value?.toFixed(2) : 'N/A'
                              : 'N/A'}
                            {(round?.interviewType === 'ASSESMENT' ||
                              round?.interviewType === 'EXTERNAL_ASSESMENT') &&
                              '%'}
                          </div>
                        </RightFlex>
                      ))
                    )}
                  </div>
                </EvaluationCard>
              )}
            </p>
          </Panel>
        </CollapseComp>
      ),
    }
  })

  function hasOnlyOneKey(array) {
    for (let item of array) {
      if (Object.keys(item).length !== 1) {
        return false
      }
    }
    return true
  }

  const isValidArray = hasOnlyOneKey(evaluationData)

  return (
    <Container
      style={{
        padding: '20px',
        borderTop: '1px solid #E6E7EA',
      }}
    >
      <LeftDiv>
        <StickyDiv>
          {isValidArray ? (
            <div
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '40px',
                fontSize: '18px',
              }}
            >
              Drive is not scheduled for this candidate
            </div>
          ) : null}
          <AntdStepsWithPanel
            current={completedStep}
            steps={stepsData}
            checkLine={true}
          />
        </StickyDiv>
      </LeftDiv>
    </Container>
  )
}

export default Evaluation
